"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var metricValue_1 = require("../../features/metricValue");
var threshold_1 = require("../../features/threshold");
var localization_1 = require("../../localization");
exports.historicalComparisonRowSubtitle = function (definition) {
    return function (currentPoint) {
        var timestampAccessor = metricValue_1.buildTimestampAccessor(definition);
        var comparisonTimestampAccessor = threshold_1.buildFirstThresholdTimestampAccessor(definition);
        var dateFormatter = metricValue_1.getDateFormatter(definition);
        var currentPointDate = timestampAccessor(currentPoint);
        var comparisonDate = comparisonTimestampAccessor && comparisonTimestampAccessor(currentPoint);
        if (!currentPointDate || !comparisonDate) {
            return localization_1.Messages.metricsNoComparisonRowSubtitle();
        }
        return dateFormatter.comparisonWidget(currentPointDate, comparisonDate);
    };
};
//# sourceMappingURL=historicalComparisonSubtitle.js.map